/**
 * Phone number field: flag + country code; `value`/`onChange` in E.164 when valid.
 *
 * Library CSS must be imported (this file already `import 'react-phone-number-input/style.css'`).
 * Import via `react-phone-number-input/min` + ESM to avoid CRA bundle issues with `min/index.cjs`.
 */
import React from 'react';
// `react-phone-number-input/min` + dist ESM: avoids CRA bundling `min/index.cjs` as a URL (React treats default export as string).
import PhoneInputLib from 'react-phone-number-input/min';
import 'react-phone-number-input/style.css';
import { cn } from './cn';
export function PhoneInput({ id, value, onChange, disabled, placeholder = 'Phone number', defaultCountry = 'US', className, 'aria-invalid': ariaInvalid, }) {
    return (React.createElement("div", { className: cn('phone-input-field w-full min-w-0', className) },
        React.createElement(PhoneInputLib, { id: id, international: true, defaultCountry: defaultCountry, countryCallingCodeEditable: false, placeholder: placeholder, value: value || undefined, onChange: (v) => onChange(v !== null && v !== void 0 ? v : ''), disabled: disabled, className: "PhoneInput", "aria-invalid": ariaInvalid, autoComplete: "tel" })));
}
